var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "canvas::editor-admin-VersionActions ml-auto flex items-center",
    },
    [
      _c(
        "div",
        {
          staticClass: "flex",
          class: {
            "opacity-25": !_vm.useVersioning,
            "pointer-events-none": !_vm.useVersioning,
          },
        },
        [
          _vm.conceptRevertable
            ? _c(
                "button",
                {
                  staticClass:
                    "bg-red-400 ease-in-out flex focus:ring-2 focus:ring-offset-2 focus:ring-red-400 focus:shadow-outline-red font-medium hover:bg-red-500 hover:text-white items-center justify-center leading-6 mr-5 px-5 py-2 rounded-md text-base text-sm text-white transition",
                  attrs: { disabled: _vm.versionState === "live" },
                  on: { click: _vm.resetCanvasVersion },
                },
                [_vm._v("\n            Wijzigingen verwijderen\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.useVersioning
            ? _c(
                "button",
                {
                  staticClass:
                    "bg-green-400 ease-in-out flex focus:border-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2 font-medium hover:bg-green-500 hover:text-white items-center justify-center leading-6 mr-5 px-5 py-2 rounded-md text-base text-sm text-white transition",
                  class: { "ml-4": !_vm.conceptRevertable },
                  attrs: { disabled: _vm.versionState === "live" },
                  on: { click: _vm.activateCanvasVersion },
                },
                [_vm._v("\n            Live plaatsen\n        ")]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "relative", attrs: { "x-data": "{ tooltip: false }" } },
        [
          _c("i", {
            staticClass: "fas fa-info-circle text-blue-400 mr-5 cursor-pointer",
            attrs: {
              "x-on:mouseover": "tooltip = true",
              "x-on:mouseleave": "tooltip = false",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "relative",
              attrs: {
                "x-cloak": "",
                "x-show.transition.origin.left": "tooltip",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "absolute right-0 z-10 w-auto p-2 mr-12 w-auto text-sm leading-tight text-gray-600 transform -translate-y-full bg-white rounded-md shadow-md whitespace-nowrap",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.useVersioning
                          ? "Wijzigingen worden niet direct live geplaatst."
                          : "Omdat je lokaal werkt worden wijzigingen direct bewaard."
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }